var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTag = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.65417 8.71694L4.5595 14.4503C3.89683 15.3769 3.89683 16.6236 4.5595 17.5503L8.65417 23.2836C9.15417 23.9836 9.96217 24.3996 10.8235 24.3996H25.3342C26.8075 24.3996 28.0008 23.2063 28.0008 21.7329V10.2663C28.0008 8.79294 26.8075 7.59961 25.3342 7.59961H10.8235C9.96217 7.59961 9.15417 8.01561 8.65417 8.71694Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0971 14.3026C15.0343 15.2398 15.0343 16.7594 14.0971 17.6967C13.1598 18.6339 11.6402 18.6339 10.7029 17.6967C9.76569 16.7594 9.76569 15.2398 10.7029 14.3026C11.6402 13.3653 13.1598 13.3653 14.0971 14.3026",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTag, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tag.dc5b22a2.svg";
export { ForwardRef as ReactComponent };